import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"30vh"} }, "404", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-h2",
  style: {"opacity":"0.4"}
}, "Oops. Nada por aquí...", -1)

import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorNotFound',
  setup(__props) {

const router = useRouter()

function goBack() {
  router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline-primary mt-5",
        onClick: goBack
      }, " Volver ")
    ])
  ]))
}
}

})